export default [{"id":"1","startTime":0,"endTime":8700,"text":"<b>Anschließend kommt es in die erste Maschine zum Stanzen.</b>"}];